import React, { useState } from 'react';
import PropTypes from 'prop-types';

export default function CourseForm({ course, onSave, onCancel }) {
  const [name, setName] = useState(course?.name || '');
  const [description, setDescription] = useState(course?.description || '');
  const [learningGoals, setLearningGoals] = useState(course?.learningGoals || '');
  const [objectives, setObjectives] = useState(course?.objectives || '');

  const handleSave = () => {
    onSave({
      id: course?.id,
      name,
      description,
      learningGoals,
      objectives,
    });
  };

  const cardClass = 'bg-white rounded-lg shadow p-6';
  const cardHeaderClass = 'mb-4';
  const cardTitleClass = 'text-2xl font-bold text-gray-800';
  const cardDescriptionClass = 'text-gray-600 mt-1';
  const formGroupClass = 'grid gap-2';
  const labelClass = 'block text-sm font-medium text-gray-700';
  const inputClass = 'mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm';
  const textareaClass = `${inputClass} min-h-[80px]`;
  const buttonGroupClass = 'flex justify-end gap-2 mt-6';
  const primaryButtonClass = 'px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200';
  const ghostButtonClass = 'px-4 py-2 text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors duration-200';

  return (
    <div className={cardClass}>
      <div className={cardHeaderClass}>
        <h2 className={cardTitleClass}>{course ? 'Edit Course' : 'Create New Course'}</h2>
        <p className={cardDescriptionClass}>
          Define the course details, learning goals, and objectives.
        </p>
      </div>
      <div className="grid gap-6">
        <div className={formGroupClass}>
          <span htmlFor="course-name" className={labelClass}>Course Name</span>
          <input
            id="course-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g., Advanced Safety Protocols"
            className={inputClass}
          />
        </div>
        <div className={formGroupClass}>
          <span htmlFor="course-description" className={labelClass}>Description</span>
          <textarea
            id="course-description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Brief description of the course content"
            className={textareaClass}
          />
        </div>
        <div className={formGroupClass}>
          <span htmlFor="learning-goals" className={labelClass}>Learning Goals</span>
          <textarea
            id="learning-goals"
            value={learningGoals}
            onChange={(e) => setLearningGoals(e.target.value)}
            placeholder="e.g., By the end of this course, participants will be able to..."
            className={textareaClass}
          />
          <p className="text-sm text-gray-500">
            Overall aims and aspirations for the learner.
          </p>
        </div>
        <div className={formGroupClass}>
          <span htmlFor="objectives" className={labelClass}>Learning Objectives</span>
          <textarea
            id="objectives"
            value={objectives}
            onChange={(e) => setObjectives(e.target.value)}
            placeholder="e.g., Upon completion, learners will be able to: 1. Identify hazards..."
            className={textareaClass}
          />
          <p className="text-sm text-gray-500">
            Specific, measurable outcomes learners should achieve.
          </p>
        </div>
        <div className={buttonGroupClass}>
          <button type="button" className={ghostButtonClass} onClick={onCancel}>
            Cancel
          </button>
          <button type="button" className={primaryButtonClass} onClick={handleSave}>
            Save Course
          </button>
        </div>
      </div>
    </div>
  );
}
CourseForm.propTypes = {
  course: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    description: PropTypes.string,
    learningGoals: PropTypes.string,
    objectives: PropTypes.string,
  }),
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

CourseForm.defaultProps = {
  course: null,
};
